import React, { useCallback } from 'react';
import * as Yup from 'yup';
import GenericModalForm from '../../components/GenericModalForm';
import GenericTextInput from '../../components/GenericTextInput';
import { ModalRef } from '../../hooks/useModalRef';
import styled from 'styled-components';
import GenericModal from '../../components/GenericModal';
import { FormikHelpers } from 'formik';
import useStoreProducts, {
  CreateStoreProductDto,
} from '../../services/swr/useStoreProducts';

// const AddStoreProductModal = React.forwardRef((schoolId, ref) => {

interface ComponentProps {
  schoolId: string;
}

const AddStoreProductModal = React.forwardRef(
  ({ schoolId }: ComponentProps, ref) => {
    // const { schoolId } = props;
    const { createStoreProduct } = useStoreProducts(schoolId);

    const closeModal = useCallback(
      () => (ref as ModalRef).current?.closeModal(),
      [ref],
    );

    const onSubmit = useCallback(
      async (
        values: Record<string, unknown>,
        { setSubmitting, resetForm }: FormikHelpers<Record<string, unknown>>,
      ) => {
        const addStudentDTO = {
          name: values.name,
          description: values.description,
          price: Number(values.price),
          cashPrice: values.cashPrice || 0,
          stockQuantity: Number(values.stockQuantity),
          tags: values.tags as string,
          imageUrl: values.imageUrl as string,
          schoolId: schoolId,
        } as CreateStoreProductDto;
        await createStoreProduct(addStudentDTO);

        setSubmitting(false);
        resetForm();
        closeModal();
      },
      [createStoreProduct, closeModal],
    );

    return (
      <ModalContainer ref={ref}>
        <ModalContent>
          <h1 className="modal-title">Adicionar Produto</h1>
          {/* name: string; description: string; price: number; cashPrice: string;
          stockQuantity: number; tags: string; imageUrl:
          string; */}
          <GenericModalForm
            initialValues={{
              name: '',
              description: '',
              price: 0,
              cashPrice: 0,
              stockQuantity: 0,
              tags: '',
              imageUrl: '',
            }}
            validationSchema={Yup.object().shape({
              name: Yup.string().required('Nome obrigatório'),
              description: Yup.string()
                .required('Descrição obrigatória')
                .min(5, 'A descrição deve ter pelo menos 5 caracteres'),
              price: Yup.number()
                .required('Preço obrigatório')
                .min(0, 'O preço deve ser maior ou igual a zero'),
              stockQuantity: Yup.number()
                .required('Quantidade em estoque obrigatória')
                .min(
                  0,
                  'A quantidade em estoque deve ser maior ou igual a zero',
                ),
              imageUrl: Yup.string()
                .required('URL da imagem obrigatória')
                .url('Digite uma URL válida'),
            })}
            onSubmit={onSubmit}
            onCancel={closeModal}
            submitButtonType="create"
          >
            <GenericTextInput
              name="name"
              label="Nome do Produto"
              type="text"
              placeholder="Gift Card"
            />
            <GenericTextInput
              name="description"
              label="Descrição do Produto"
              type="text"
              placeholder="Gift Card para Steam"
            />
            <GenericTextInput
              name="price"
              label="Preço (coins)"
              type="number"
              placeholder="10.00"
            />
            <GenericTextInput
              name="cashPrice"
              label="Preço (R$) - Opcional"
              type="number"
              placeholder="10.00"
            />
            <GenericTextInput
              name="stockQuantity"
              label="Quantidade em Estoque"
              type="number"
              placeholder="100"
            />
            <GenericTextInput
              name="tags"
              label="Tags"
              type="text"
              placeholder="gift, card, steam"
            />
            <GenericTextInput
              name="imageUrl"
              label="URL da Imagem"
              type="text"
              placeholder="https://example.com/image.jpg"
            />
          </GenericModalForm>
        </ModalContent>
      </ModalContainer>
    );
  },
);

AddStoreProductModal.displayName = 'AddStoreProductModal';

export const ModalContainer = styled(GenericModal)`
  width: 100%;
  max-width: 600px;
`;

export const ModalContent = styled.div`
  .modal-title {
    font-family: var(--font-sans);
    font-size: 1.563rem;

    margin-bottom: 24px;
  }
`;

export default AddStoreProductModal;
